import { render } from "./RegisterUserView.vue?vue&type=template&id=6d9130a0"
import script from "./RegisterUserView.vue?vue&type=script&lang=js"
export * from "./RegisterUserView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__